import React from 'react';
import Marquee from 'react-fast-marquee';
export function TrustedBy() {
  const logos = [{
    src: 'https://uploadthingy.s3.us-west-1.amazonaws.com/oHvhAMpGPTENH6T8kLxToH/Redberry.png',
    alt: 'Redberry logo'
  }, {
    src: 'https://uploadthingy.s3.us-west-1.amazonaws.com/f8RMMPQ9wXAouPzQeFb4HH/zeitraum.png',
    alt: 'Zeitraum logo'
  }, {
    src: 'https://uploadthingy.s3.us-west-1.amazonaws.com/dJygXeff92ytqqykD1qMyP/byte_5.png',
    alt: 'Byte 5 logo'
  }, {
    src: 'https://uploadthingy.s3.us-west-1.amazonaws.com/aqnBgwZeYCctU9edQpwCmS/Studio_fifteen.png',
    alt: 'Studio Fifteen logo'
  }, {
    src: 'https://uploadthingy.s3.us-west-1.amazonaws.com/x71oEZRLPmfkN5RYBYnVbo/Untitled_design_%281%29.png',
    alt: 'Company logo'
  }, {
    src: 'https://uploadthingy.s3.us-west-1.amazonaws.com/5VxoAvWougwoHZ22bvboww/BBStudio.png',
    alt: 'Big Boss Studio logo'
  }, {
    src: 'https://uploadthingy.s3.us-west-1.amazonaws.com/dCYSTxpFieUP2S5yFJdpsN/Neusta.png',
    alt: 'Neusta logo'
  }, {
    src: 'https://uploadthingy.s3.us-west-1.amazonaws.com/5Xj3R3Di9ZSojPJXjTUnup/pocket_data.png',
    alt: 'Pocket Data logo'
  }, {
    src: 'https://uploadthingy.s3.us-west-1.amazonaws.com/2aGzMHobZXU2BSSfLwrvjP/red_chameleon.png',
    alt: 'Red Chameleon Web Agency logo'
  }, {
    src: 'https://uploadthingy.s3.us-west-1.amazonaws.com/sXPsKAwNFQr89x8iqwSfna/webtual.png',
    alt: 'Webtual logo'
  }];
  return <section className="py-8 sm:py-12 bg-white" data-id="element-377">
      <div className="container mx-auto px-4 max-w-7xl" data-id="element-378">
        <p className="text-center text-sm sm:text-base text-gray-600 mb-6 sm:mb-8" data-id="element-379">
          Trusted by Laravel-driven teams worldwide.
        </p>
        <Marquee speed={40} gradient={false} pauseOnHover={true} className="py-3 sm:py-4" data-id="element-380">
          {logos.map((logo, i) => <div key={i} className="h-12 sm:h-16 md:h-20 flex items-center justify-center mx-4 sm:mx-6 md:mx-8" data-id="element-381">
              <img src={logo.src} alt={logo.alt} className="h-full object-contain" data-id="element-382" />
            </div>)}
        </Marquee>
        <div className="mt-12 sm:mt-16 max-w-3xl mx-auto px-4" data-id="element-383">
          <div className="bg-gray-50 rounded-2xl p-6 sm:p-8 md:p-10 border border-gray-100 text-center" data-id="element-384">
            <svg className="h-8 w-8 sm:h-9 sm:w-9 text-primary/30 mx-auto mb-4" fill="currentColor" viewBox="0 0 32 32" aria-hidden="true" data-id="element-385">
              <path d="M9.352 4C4.456 7.456 1 13.12 1 19.36c0 5.088 3.072 8.064 6.624 8.064 3.36 0 5.856-2.688 5.856-5.856 0-3.168-2.208-5.472-5.088-5.472-.576 0-1.344.096-1.536.192.48-3.264 3.552-7.104 6.624-9.024L9.352 4zm16.512 0c-4.8 3.456-8.256 9.12-8.256 15.36 0 5.088 3.072 8.064 6.624 8.064 3.264 0 5.856-2.688 5.856-5.856 0-3.168-2.304-5.472-5.184-5.472-.576 0-1.248.096-1.44.192.48-3.264 3.456-7.104 6.528-9.024L25.864 4z" data-id="element-386" />
            </svg>
            <blockquote data-id="element-387">
              <p className="text-base sm:text-lg md:text-xl font-medium text-gray-800 leading-relaxed" data-id="element-388">
                "This platform has transformed how we assess Laravel developers.
                The technical challenges perfectly match real-world scenarios,
                and the automated evaluation saves our team countless hours.
                We've improved our hiring quality dramatically."
              </p>
            </blockquote>
            <div className="mt-5 sm:mt-6 pt-5 sm:pt-6 border-t border-gray-200" data-id="element-389">
              <p className="font-semibold text-gray-900 text-sm sm:text-base" data-id="element-390">
                Sarah Johnson
              </p>
              <p className="text-xs sm:text-sm text-gray-500 mt-0.5" data-id="element-391">
                CTO at TechNova
              </p>
            </div>
          </div>
        </div>
      </div>
    </section>;
}